var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1_1",
    transform: "translate(-881.000000, -487.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(485.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-4",
    transform: "translate(384.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-outline",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,19.25 L11,19.25 C9.48121694,19.25 8.25,18.0187831 8.25,16.5 L8.25,11 C8.25,9.48121694 9.48121694,8.25 11,8.25 L16.5,8.25 C18.0187831,8.25 19.25,9.48121694 19.25,11 L19.25,16.5 C19.25,18.0187831 18.0187831,19.25 16.5,19.25 Z M11,10.0833333 C10.493739,10.0833333 10.0833333,10.493739 10.0833333,11 L10.0833333,16.5 C10.0833333,17.006261 10.493739,17.4166667 11,17.4166667 L16.5,17.4166667 C17.006261,17.4166667 17.4166667,17.006261 17.4166667,16.5 L17.4166667,11 C17.4166667,10.493739 17.006261,10.0833333 16.5,10.0833333 L11,10.0833333 Z",
    id: "Shape",
    fill: "#1D2B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91916667,13.75 L5.1975,13.75 C3.84787065,13.7449734 2.7550266,12.6521294 2.75,11.3025 L2.75,5.1975 C2.7550266,3.84787065 3.84787065,2.7550266 5.1975,2.75 L11.3025,2.75 C12.6521294,2.7550266 13.7449734,3.84787065 13.75,5.1975 L13.75,8.61666667 L11.9166667,8.61666667 L11.9166667,5.1975 C11.9166667,4.85830512 11.6416949,4.58333333 11.3025,4.58333333 L5.1975,4.58333333 C4.85830512,4.58333333 4.58333333,4.85830512 4.58333333,5.1975 L4.58333333,11.3025 C4.58333333,11.6416949 4.85830512,11.9166667 5.1975,11.9166667 L8.91916667,11.9166667 L8.91916667,13.75 Z",
    id: "Path",
    fill: "#1D2B7D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.fe7c90af46a851df0a42e5807515b1be.svg";
export { ForwardRef as ReactComponent };